
import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface VideoErrorProps {
  error: string;
  retries: number;
  onRetry: () => void;
}

export function VideoError({ error, retries, onRetry }: VideoErrorProps) {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-80 text-white p-6">
      <AlertTriangle className="h-10 w-10 text-yellow-400 mb-4" />
      <h3 className="text-lg font-medium mb-2">Video Playback Error</h3>
      <p className="text-sm mb-4 max-w-md text-center">{error}</p>
      <div className="flex gap-3">
        <Button 
          onClick={onRetry} 
          variant="outline" 
          className="bg-white text-black hover:bg-gray-200 flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Retry Video
        </Button>
        {retries > 2 && (
          <Button onClick={() => window.location.reload()} variant="destructive">
            Refresh Page
          </Button>
        )}
      </div>
    </div>
  );
}
